module.exports = __webpack_public_path__ + "static/VM-Pressed@2x-7812317ded117c9c92b78705689ed76b.png";